import { Divider, Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import {
    Control,
    FieldErrors,
    UseFormRegister,
    UseFormReset,
    UseFormSetValue,
} from "react-hook-form";
import { shallowEqual, useSelector } from "react-redux";
import { bindDropDown, callAPI, dateFormat, IsSmallScreen, Method } from "../../commonFunctions/CommonFunctions";
import WSButton from "../../Components/Button/WSButton";
import WSDateField from "../../Components/DateField/WSDateField";
import WSHiddenField from "../../Components/HiddenField/WSHiddenField";
import WSSelectField from "../../Components/Select/WSSelect";
import WSTextField, { CurrencyType, TextType } from "../../Components/TextBox/WSTextBox";
import WSTextAreaField from "../../Components/WSTextArea/WSTextArea";
import config from "../../Config/clientConfig.json";
import { AppState } from "../../StateManagement/types";
interface DealsProps {
    control?: Control<any>;
    errors?: FieldErrors;
    register: UseFormRegister<any>;
    id: any;
    reset: UseFormReset<any>;
    dealId?: string;
    setValue: UseFormSetValue<any>;
    onCancel: () => void
}

const DealsDrawyer: React.FC<DealsProps> = ({
    control, id, register, dealId, reset, setValue, onCancel
}) => {
    const [leadData, setLeadData] = useState([]);
    const [loading, setLoading] = useState(false);
    const isMobile = IsSmallScreen()
    useEffect(() => {
        reset();
    }, [id, reset]);

    useEffect(() => {
        async function getDeals() {
            const response: any = await callAPI('deals', Method.GET, null, dealId);
            if (response) {
                const dealsData: any = response;
                setValue('dealName', dealsData?.dealName)
                setValue('amount', dealsData?.amount)
                setValue('stage', dealsData?.stage)
                setValue('status', dealsData?.status)
                setValue('closeDate', dateFormat(response?.closeDate, 'DD-MM-YYYY HH:mm:ss'))
                setValue('leadId', dealsData?.leadId)
                setValue('dealOwner', dealsData?.dealOwner)
                setValue('customerType', dealsData?.customerType)
                setValue('nextStep', dealsData?.nextStep)
                setValue('source', dealsData?.source)
                setValue('profitability', dealsData?.profitability)
                setValue('expectedRevenue', dealsData?.expectedRevenue)
                setValue('campaignSource', dealsData?.campaignSource)
                setValue('notes', dealsData?.notes)
            }

        }
        if (dealId) {
            getDeals();
        }
    }, [dealId])
    const reduxComponentData = useSelector(
        (state: AppState) => state.components["dealSubmit"],
        shallowEqual
    );

    // Local state to store Redux data
    const [componentData, setComponentData] = useState(reduxComponentData);

    // Update useState when Redux state changes
    useEffect(() => {
        if (reduxComponentData) {
            setComponentData(reduxComponentData);
        }
    }, [reduxComponentData]);
    useEffect(() => {
        try {
            async function getLeads() {
                const response: any = await bindDropDown('leads', 'firstName', 'id', Method.GET, ['firstName', 'lasttName'], { field: 'leadType', value: 0 })
                setLeadData(response)
            }
            getLeads()
        }

        catch (e) {

        }
    }, [])


    return (
        <Grid >
            {
                <Grid container spacing={2} mt={2}>
                    <Grid item xs={12}>
                        <Typography fontWeight={"bold"}>Deal Information</Typography>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <WSTextField
                            label={"Deal Name"}
                            {...register("dealName")}
                            id="dealName"
                            name="dealName"
                            control={control}
                            rules={{ required: true }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <WSTextField
                            label={"Amount"}
                            {...register("amount")}
                            id="amount"
                            name="amount"
                            control={control}
                            rules={{ required: true }}
                            type={TextType.Currency}
                            currency={CurrencyType.Rupee}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <WSSelectField
                            label={"Stage"}
                            {...register("stage")}
                            isMobile={isMobile}
                            id="stage"
                            name="stage"
                            options={[{ label: 'New', value: 'new' }]}
                            control={control}
                            rules={{ required: true }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <WSSelectField
                            label={"Customer Type"}
                            {...register("customerType")}
                            id="customerType"
                            name="customerType"
                            options={config.customertypeconfig.staticOptionData}
                            control={control}
                            isMobile={isMobile}
                            rules={{ required: true }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <WSDateField
                            id="closeDate"
                            name="closeDate"
                            label={"Closing Date"}
                            dateFormat="DD-MM-YYYY"
                            denyFuturOrPast="custom"
                            control={control}
                            setValue={setValue}
                            rules={{ required: true }}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <WSSelectField
                            options={config.leadSourceConfig.staticOptionData}
                            rules={{ required: true }}
                            {...register("source")}
                            id="source"
                            isMobile={isMobile}
                            control={control}
                            defaultValue={"0"}
                            label="source"
                            name="source"
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <WSTextField
                            label={"Probability(%)"}
                            {...register("profitability")}
                            id="profitability"
                            name="profitability"
                            control={control}
                            rules={{ required: true }}
                            type={TextType.Number}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <WSTextField
                            label={"Next Step"}
                            {...register("nextStep")}
                            id="nextStep"
                            name="nextStep"
                            control={control}
                            rules={{ required: true }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <WSTextField
                            label={"Expected Revenue"}
                            {...register("expectedRevenue")}
                            id="expectedRevenue"
                            name="expectedRevenue"
                            control={control}
                            rules={{ required: true }}
                            type={TextType.Currency}
                            currency={CurrencyType.Dollar}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <WSTextField
                            label={"Campaign Source"}
                            {...register("campaignSource")}
                            id="campaignSource"
                            name="campaignSource"
                            control={control}
                            rules={{ required: true }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <WSSelectField
                            label={"Status"}
                            {...register("status")}
                            isMobile={isMobile}
                            id="status"
                            name="status"
                            options={[{ label: 'New', value: 'new' }]}
                            control={control}
                            rules={{ required: true }}
                        />
                    </Grid>
                    <Grid item xs={12} mt={2}>
                        <Typography fontWeight={"bold"}>
                            Description Information
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <WSTextAreaField
                            label="Description"
                            id="notes"
                            control={control}
                            {...register("notes")}
                            rules={{ required: false }}
                            name="notes"
                            rows={2}
                        />


                        <WSHiddenField control={control} name="dealId" defaultValue={dealId} />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <Divider />
                    </Grid>
                    <Grid item container spacing={2} style={{ paddingTop: '1rem' }} justifyContent={'end'}>
                        <Grid item sx={{ marginRight: 0 }}>
                            <WSButton className="ws-theme-crm" loading={reduxComponentData?.data?.loading} variant="outlined" id='dealSubmit' label={"Save"} type="submit" size="medium" />
                        </Grid>
                        <Grid item sx={{ marginRight: 0 }}>
                            <WSButton id='cancel' label={"Cancel"} onClick={onCancel} type="button" size="medium" variant="outlined" className="ws-theme-crm" />
                        </Grid>
                    </Grid>
                </Grid >

            }
        </Grid >
    );
};
export default DealsDrawyer;
